import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-lock",
  "use": "icon-lock-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-lock\">\n\t<path fill=\"none\" d=\"M0,0H24V24H0Z\" />\n\t<path d=\"M15.89,10.89h.55a.56.56,0,0,1,.56.55V17a.56.56,0,0,1-.56.56H7.56A.56.56,0,0,1,7,17V11.44a.56.56,0,0,1,.56-.55h.55v-.56a3.89,3.89,0,0,1,7.78,0Zm-1.11,0v-.56a2.78,2.78,0,0,0-5.56,0v.56Zm-3.34,2.22v2.22h1.12V13.11Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol